<template>
  <div class="container" @click="handleClick">
    <h3>{{ title }}</h3>
    <span>{{ body }}</span>
  </div>
</template>

<script>
import Vue from '@/main'

export default {
  name: "Toast",
  props: {
    title: String,
    body: String,
    to: String,
  },
  methods: {
    handleClick() {
      let url = this.to;

      if (process.env.NODE_ENV === 'production' && url.startsWith('/member/')) {
        url = url.replace('/member/', '/');
      }

      Vue.$router.push(url);
      this.$emit('close-toast');
    },
  }
}
</script>

<style scoped>
  .container {
    cursor: pointer;
  }
</style>
